module.exports = __webpack_public_path__ + "img/ETHOS.693e3b6c.svg";